import { API_URL } from "@/config";
import {axios} from "@/lib/axios";
import {ConfirmAdminData, SetPasswordResponse} from "@/features/Admins/types";

export const confirmAdmin = (data: ConfirmAdminData): Promise<SetPasswordResponse> => {
    return axios.post(`${API_URL}/api/security/admin/registration/finish`, data);
};


